/**
 * @generated SignedSource<<344fc8cf7ac14f9432f9a745f9d5a146>>
 * @relayHash 0938e0409fdcb6f0a50520bf2581e98b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b8b865763f499dc25711d949c0dd7fd088abbadfc17a652a14916547740df164

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b8b865763f499dc25711d949c0dd7fd088abbadfc17a652a14916547740df164",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
